<div class="seletor-comissao">
    <input pInputText class="campo-selecao" [value]="descricaoSelecionada" [placeholder]="placeholder()" readonly [disabled]="desabilitado" (click)="abrirDialogo()" />
    <button type="button" class="botao-icone" [disabled]="desabilitado" (click)="abrirDialogo()" title="Buscar">
        <i class="pi pi-search"></i>
    </button>
    @if (valor) {
        <button type="button" class="botao-icone limpar" [disabled]="desabilitado" (click)="limpar()" title="Limpar">
            <i class="pi pi-times"></i>
        </button>
    }
</div>

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Escolha a estrutura na hierarquia."
    closeAriaLabel="Fechar"
    [header]="tituloDialogo()"
    [(visible)]="exibirDialog"
    [style]="{ width: '720px', border: 'none' }"
    styleClass="dialogo-arvore-comissao"
    appendTo="body"
    (onHide)="onDialogHide()"
>
    <section class="dialog-arvore-comissao">
        <div class="arvore-painel">
            @if (erro()) {
                <div class="arvore-vazia erro">{{ erro() }}</div>
            } @else if (carregando()) {
                <div class="arvore-vazia">
                    <i class="pi pi-spin pi-spinner"></i>
                    <span>Carregando estruturas...</span>
                </div>
            } @else if (tiposExibicao.length) {
                <ul class="arvore-lista arvore-tipos">
                    @for (tipo of tiposExibicao; track trackTipo($index, tipo)) {
                        <li>
                            <div class="arvore-tipo">
                                <button
                                    type="button"
                                    class="arvore-toggle"
                                    [attr.aria-expanded]="tipoExpandido(tipo.idTipoComissaoCt)"
                                    [attr.aria-label]="(tipoExpandido(tipo.idTipoComissaoCt) ? 'Recolher ' : 'Expandir ') + tipo.descricao"
                                    (click)="alternarTipo(tipo.idTipoComissaoCt)"
                                >
                                    <i class="pi" [ngClass]="tipoExpandido(tipo.idTipoComissaoCt) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                                </button>
                                <i class="pi pi-folder arvore-tipo-icone"></i>
                                <span>{{ tipo.descricao }}</span>
                            </div>
                            @if (tipoExpandido(tipo.idTipoComissaoCt)) {
                                <ng-container *ngTemplateOutlet="renderNos; context: { $implicit: tipo.filhos, nivel: 1 }"></ng-container>
                            }
                        </li>
                    }
                </ul>
            } @else {
                <div class="arvore-vazia">
                    <i class="pi pi-search"></i>
                    <span>Nenhuma estrutura encontrada.</span>
                </div>
            }
        </div>

        <aside class="arvore-filtros">
            <div class="arvore-filtro-grupo">
                <span class="arvore-filtro-titulo">Filtrar por</span>
                <label><input type="radio" name="tipoFiltroComissao" value="nome" [(ngModel)]="tipoFiltro" (change)="onFiltroChange(termoFiltro)" /> Nome</label>
                <label><input type="radio" name="tipoFiltroComissao" value="codigo" [(ngModel)]="tipoFiltro" (change)="onFiltroChange(termoFiltro)" /> Código</label>
            </div>

            <div class="arvore-filtro-grupo">
                <span class="arvore-filtro-titulo">Status</span>
                <label><input type="radio" name="statusFiltroComissao" value="todos" [(ngModel)]="statusFiltro" /> Todos</label>
                <label><input type="radio" name="statusFiltroComissao" value="ativas" [(ngModel)]="statusFiltro" /> Ativas</label>
                <label><input type="radio" name="statusFiltroComissao" value="extintas" [(ngModel)]="statusFiltro" /> Extintas</label>
            </div>

            <div class="arvore-filtro-grupo">
                <span class="arvore-filtro-titulo">Pesquisa</span>
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
                    <input pInputText [ngModel]="termoFiltro" (ngModelChange)="onFiltroChange($event)" [placeholder]="tipoFiltro === 'codigo' ? 'Código' : 'Nome'" />
                </div>
            </div>

            <div class="arvore-legenda">
                <span class="legenda-extinta"></span>
                <span>Comissões extintas</span>
            </div>
        </aside>
    </section>

    <ng-template #renderNos let-nos let-nivel="nivel">
        <ul class="arvore-lista arvore-nos" [style.--nivel]="nivel">
            @for (no of nos; track trackNo($index, no)) {
                <li>
                    <div class="arvore-no" [class.selecionado]="noSelecionado?.id === no.id" [class.extinta]="no.ativo === 0" (click)="selecionarNo(no)">
                        @if (no.filhos.length) {
                            <button
                                type="button"
                                class="arvore-toggle"
                                [attr.aria-expanded]="noExpandido(no.id)"
                                [attr.aria-label]="(noExpandido(no.id) ? 'Recolher ' : 'Expandir ') + no.descricao"
                                (click)="$event.stopPropagation(); alternarNo(no.id)"
                            >
                                <i class="pi" [ngClass]="noExpandido(no.id) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                            </button>
                        } @else {
                            <span class="arvore-toggle-placeholder"></span>
                        }
                        <i class="pi pi-sitemap arvore-no-icone"></i>
                        <span class="arvore-no-codigo">{{ no.id }}</span>
                        <span class="arvore-no-descricao">{{ no.descricao }}</span>
                    </div>
                    @if (no.filhos.length && noExpandido(no.id)) {
                        <ng-container *ngTemplateOutlet="renderNos; context: { $implicit: no.filhos, nivel: nivel + 1 }"></ng-container>
                    }
                </li>
            }
        </ul>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="rodape-dialogo">
            <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="cancelar()"></button>
            <button type="button" pButton label="OK" icon="pi pi-check" [disabled]="!noSelecionado" (click)="confirmar()"></button>
        </div>
    </ng-template>
</p-dialog>
